module.exports = __webpack_public_path__ + "static/media/1.f526f5ff.png";